import { useData } from '../context/DataContext';
import './Legal.css';

export default function Terms() {
  const { data, loading } = useData();
  if (loading || !data) return <div className="page">Loading...</div>;
  const { company } = data;

  return (
    <main className="page legal-page">
      <div className="container">
        <div className="section-title">
          <span className="section-title__label">Legal</span>
          <h1 className="section-title__heading">Terms of Service</h1>
          <p className="section-title__description">Last updated: April 2026</p>
        </div>

        <div className="legal-page__content">
          <section className="legal-page__section">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using {company.fullName} (&quot;IWX&quot;) products and services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.</p>
          </section>

          <section className="legal-page__section">
            <h2>2. Use of Services</h2>
            <p>You may use IWX services for lawful purposes only. You agree not to misuse our platforms, attempt to gain unauthorized access, or interfere with the proper functioning of our services.</p>
          </section>

          <section className="legal-page__section">
            <h2>3. Intellectual Property</h2>
            <p>All content, designs, code, and trademarks on IWX platforms are the property of {company.fullName}. You may not reproduce, distribute, or create derivative works without our written permission.</p>
          </section>

          <section className="legal-page__section">
            <h2>4. User Accounts</h2>
            <p>When you create an account on any IWX platform, you are responsible for maintaining the confidentiality of your credentials and for all activities under your account.</p>
          </section>

          <section className="legal-page__section">
            <h2>5. Limitation of Liability</h2>
            <p>{company.fullName} shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services. Our total liability is limited to the amount you&apos;ve paid us in the past 12 months.</p>
          </section>

          <section className="legal-page__section">
            <h2>6. Modifications</h2>
            <p>We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the updated terms.</p>
          </section>

          <section className="legal-page__section">
            <h2>7. Contact</h2>
            <p>For questions about these terms, contact us at <strong>{company.email}</strong>.</p>
          </section>
        </div>
      </div>
    </main>
  );
}
